"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = require("../products/mappers");
var address_utils_1 = require("../address-utils");
var buildBillingAddress = function (billingAddressDTO) {
    var address = billingAddressDTO && billingAddressDTO.address;
    if (!address) {
        return null;
    }
    var contactDetails = billingAddressDTO.contactDetails;
    var formattedAddress = address_utils_1.createPlatformizedWixCodeAddressObject(address);
    var billingAddress = {};
    if (contactDetails) {
        billingAddress = {
            firstName: contactDetails.firstName,
            lastName: contactDetails.lastName,
            email: contactDetails.email,
            phone: contactDetails.phone,
            company: contactDetails.company,
            vatId: contactDetails.vatId && contactDetails.vatId.id,
        };
    }
    billingAddress.address = formattedAddress;
    return billingAddress;
};
function createFormattedPickupDetails(shippingInfoDTO) {
    var address = shippingInfoDTO && shippingInfoDTO.pickupDetails && shippingInfoDTO.pickupDetails.pickupAddress;
    if (!address) {
        return null;
    }
    var buyerDetails = shippingInfoDTO.pickupDetails && shippingInfoDTO.pickupDetails.buyerDetails;
    var formattedAddress = address_utils_1.createPlatformizedWixCodeAddressObject(address);
    var pickupDetails = {};
    if (buyerDetails) {
        pickupDetails = {
            firstName: buyerDetails.firstName,
            lastName: buyerDetails.lastName,
            email: buyerDetails.email,
            phone: buyerDetails.phone,
        };
    }
    pickupDetails.pickupAddress = formattedAddress;
    return pickupDetails;
}
function createFormattedShippingAddress(shippingInfoDTO) {
    var address = shippingInfoDTO && shippingInfoDTO.shippingAddress && shippingInfoDTO.shippingAddress.address;
    if (!address) {
        return null;
    }
    var contactDetails = shippingInfoDTO.shippingAddress.contactDetails;
    var formattedAddress = address_utils_1.createPlatformizedWixCodeAddressObject(address);
    var shippingAddress = {};
    if (contactDetails) {
        shippingAddress = {
            firstName: contactDetails.firstName,
            lastName: contactDetails.lastName,
            email: contactDetails.email,
            phone: contactDetails.phone,
            company: contactDetails.company,
            vatId: contactDetails.vatId && contactDetails.vatId.id,
        };
    }
    shippingAddress.address = formattedAddress;
    return shippingAddress;
}
var buildShippingInfo = function (shippingInfoDTO) {
    var formattedPickupDetails = createFormattedPickupDetails(shippingInfoDTO);
    var formattedShippingAddress = createFormattedShippingAddress(shippingInfoDTO);
    if (!formattedPickupDetails && !formattedShippingAddress) {
        return null;
    }
    var shippingInfo = {};
    if (formattedShippingAddress) {
        shippingInfo.shippingAddress = formattedShippingAddress;
    }
    if (formattedPickupDetails) {
        shippingInfo.pickupDetails = formattedPickupDetails;
    }
    return shippingInfo;
};
var buildLineItems = function (lineItems) {
    return (lineItems || []).map(function (lineItemDTO) {
        var mediaItem = null;
        if (lineItemDTO.mediaItem) {
            var fulMediaItem = {
                mediaType: lineItemDTO.mediaItem.mediaType,
                thumbnail: {
                    height: lineItemDTO.mediaItem.height,
                    url: lineItemDTO.mediaItem.url,
                    width: lineItemDTO.mediaItem.width,
                },
                title: '',
                image: {
                    height: lineItemDTO.mediaItem.height,
                    url: lineItemDTO.mediaItem.url,
                    width: lineItemDTO.mediaItem.width,
                },
            };
            mediaItem = {
                src: mappers_1.buildImageUrl(fulMediaItem),
                type: lineItemDTO.mediaItem.mediaType,
            };
        }
        return __assign({}, lineItemDTO, { mediaItem: mediaItem, price: getNumber(lineItemDTO.price), totalPrice: getNumber(lineItemDTO.totalPrice), weight: getNumber(lineItemDTO.weight) });
    });
};
var buildTotals = function (totals) {
    return {
        discount: getNumber(totals.discount),
        quantity: totals.quantity,
        shipping: getNumber(totals.shipping),
        subtotal: getNumber(totals.subtotal),
        tax: getNumber(totals.tax),
        total: getNumber(totals.total),
        weight: getNumber(totals.weight),
    };
};
var getNumber = function (string, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    var number = Number(string);
    return isNaN(number) ? defaultValue : number;
};
var buildCurrency = function (currency) {
    return {
        symbol: currency.symbol,
        code: currency.code,
    };
};
var buildBuyerInfo = function (buyerInfo) {
    return {
        email: buyerInfo.email,
        firstName: buyerInfo.firstName,
        identityType: buyerInfo.identityType,
        lastName: buyerInfo.lastName,
        phone: buyerInfo.phone,
    };
};
var buildAppliedCoupon = function (appliedCoupon) {
    return {
        code: appliedCoupon.code,
        couponType: appliedCoupon.couponType,
        discountValue: appliedCoupon.discountValue,
        name: appliedCoupon.name,
    };
};
exports.cartMapper = function (cartDTO) {
    return {
        _id: cartDTO.id,
        status: cartDTO.status,
        billingAddress: cartDTO.billingAddress ? buildBillingAddress(cartDTO.billingAddress) : null,
        appliedCoupon: cartDTO.appliedCoupon ? buildAppliedCoupon(cartDTO.appliedCoupon) : null,
        buyerInfo: cartDTO.buyerInfo ? buildBuyerInfo(cartDTO.buyerInfo) : null,
        buyerNote: cartDTO.buyerNote,
        currency: cartDTO.currency ? buildCurrency(cartDTO.currency) : null,
        lineItems: cartDTO.lineItems ? buildLineItems(cartDTO.lineItems) : null,
        shippingInfo: cartDTO.shippingInfo ? buildShippingInfo(cartDTO.shippingInfo) : null,
        totals: cartDTO.totals ? buildTotals(cartDTO.totals) : null,
        weightUnit: cartDTO.weightUnit,
    };
};
//# sourceMappingURL=cart.mapper.js.map